import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FbHolidayListDashboardCardService } from './fb-holiday-list-dashboard-card.service';
import { take } from 'rxjs/operators';
import { CustomButtonActionService } from 'custom-button-action';
import { FormDesignerService } from '../../form-designer/form-designer.service';

@Component({
  selector: 'app-fb-holiday-list-dashboard-card',
  templateUrl: './fb-holiday-list-dashboard-card.component.html',
  styleUrls: ['./fb-holiday-list-dashboard-card.component.scss']
})
export class FbHolidayListDashboardCardComponent implements OnChanges {
  @Input() content: {
    type: string,
    title: string,
    footerLink: string,
    dashboardRedirectPageFormId?: number
  };

  pastHoliday = [];
  upcomingHoliday = [];

  constructor(
    private fbHolidayListDashboardCardService: FbHolidayListDashboardCardService,
    private customButtonActionService: CustomButtonActionService,
    private formDesignerService: FormDesignerService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.content) {
      this.fetchHolidays();
    }
  }

  fetchHolidays() {
    if (this.content) {
      this.fbHolidayListDashboardCardService.fetchHolidays()
        .pipe(take(1))
        .subscribe((holidayList: any[]) => {
          this.processHolidays(holidayList);
        });
    }
  }

  processHolidays(holidayList: any[]) {
    const currentDate = new Date();
    const sortedHolidays = holidayList.sort((a, b) => new Date(a.holidayDate).getTime() - new Date(b.holidayDate).getTime());

    sortedHolidays.forEach((holiday, index) => {
      const holidayDate = new Date(holiday.holidayDate);
      const formattedDate = `${holidayDate.getDate().toString().padStart(2, '0')} ${this.getMonthName(holidayDate.getMonth())} ${holidayDate.getFullYear()} - ${holiday.dayOfholiday}`;

      if (holidayDate < currentDate) {
        this.pastHoliday.push({
          id: index + 1,
          name: holiday.holidayName,
          date: formattedDate
        });
      } else {
        this.upcomingHoliday.push({
          id: index + 1,
          name: holiday.holidayName,
          date: formattedDate,
          nextHoliday: this.upcomingHoliday.length === 0
        });
      }
    });

    // Limit past holidays to the two most recent ones
    this.pastHoliday = this.pastHoliday.slice(-2);
    // Limit upcoming holidays to the 5 upcoming ones
    this.upcomingHoliday = this.upcomingHoliday.slice(0, 5);
  }

  getMonthName(monthIndex: number): string {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
    return monthNames[monthIndex];
  }

  footerRedirect() {
    sessionStorage.removeItem('redirectId');
    sessionStorage.setItem('redirectId', this.content.dashboardRedirectPageFormId.toString());
    this.formDesignerService.setDashboardLink(true);
    this.customButtonActionService.getPageFormById(this.content.dashboardRedirectPageFormId)
      .pipe(take(1)).subscribe((response: any) => {
        if (response) {
          const item = {
            formType: response.buildFormatTypeId,
            pageFormId: response.id
          }
          // if (this.isBeneficiaryProfileListing) {
          //   sessionStorage.setItem('FbEmployeeId', rowData.fb_beneficiaryId);
          //   sessionStorage.setItem('FbActualEmployeeId', rowData.fb_employeeId);
          // } else {
          // sessionStorage.setItem('formDataId', rowData.id);
          // }
          this.customButtonActionService.onLinkRedirectPageSubject.next(item);
        }
      });
  }

}
